import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <h1>Isaiah's Blog</h1>
      <p>Howdy! I'm Isaiah, an interoperability/software engineer and aspiring machine alignment researcher. This site is a loose collection of various projects, whether they be quick blog posts regarding the topic of the week, or intermittent informal reports on research progress.</p>
			<p>My ongoing fixation for the past several years has been Mech Interp, with my current focus being the training dynamics and causal downstream effects of Language Model Probes.</p>
			<p>My primary motivation for studying mech interp is for alignment. Towards that end, I believe we should be striving for methods that are Scalable, Unsupervised, and Causal. My secondary motivation is for exploration: deep neural networks can solve problems that humans are unable to write algorithms for; there is certainly a lesson to be learned there.</p>
	<p>Towards the goal of improving our understanding of probes, I have elected to perform a series of experiments investigating the affects of different types of training setups. Here is the first of many: <Link to="/articles/probe-experiment-1">Adding Non-Task Classes</Link>
      </p>
    </div>
  );
}

export default Home;
